import BlSliderMv from './BlSliderMv.vue'

BlSliderMv.install = function(Vue) {
  Vue.component(BlSliderMv.name, BlSliderMv)
}

export default BlSliderMv
